import defaultAttributes from '../defaultAttributes';

const FlagTriangleLeft = [
  'svg',
  defaultAttributes,
  [['path', { d: 'M17 22V2L7 7l10 5' }]],
];

export default FlagTriangleLeft;
